import State from '../core/State';
import { ProjectTypeDetailFragment } from '../generated/graphql';

export const setIsOpenDesignInspirationScreen = (isOpenDesignInspirationScreen: boolean) => (state: State): State => {
  return {
    ...state,
    isOpenDesignInspirationScreen,
  };
};

export const setProjectType = (projectType: ProjectTypeDetailFragment) => (state: State): State => {
  return {
    ...state,
    projectEditing: {
      ...state.projectEditing,
      projectType,
    },
  };
};
